import React from 'react';

import { showPrices } from '../constants/settings';
import { getFormattedProductPrice } from '../utils/priceFormatter';

export default function SuggestedProductContent({
  product,
  getCoverImageForProduct,
}) {
  const coverImage = getCoverImageForProduct(product);
  const formattedPrice = getFormattedProductPrice(product);
  const shouldShowPrice = showPrices && formattedPrice;

  return (
    <div className="suggested-product-content">
      {coverImage?.imageURL && (
        <img
          src={coverImage.imageURL}
          alt={product.productName}
          className="suggested-product-image"
        />
      )}
      <div className="suggested-product-info">
        <span className="suggested-product-name">{product.productName}</span>
        {shouldShowPrice ? (
          <span className="suggested-product-price">
            {formattedPrice}
          </span>
        ) : null}
      </div>
    </div>
  );
}
